"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_APPROVER_REPLACEMENT_HISTORY = void 0;
exports.LIST_APPROVER_REPLACEMENT_HISTORY = {
    USER_NOT_FOUND: {
        usecase: 'LIST_APPROVER_REPLACEMENT_HISTORY',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
            'EN-US': 'User not found.',
        },
    },
    UNAUTHORIZED_ACTOR: {
        usecase: 'LIST_APPROVER_REPLACEMENT_HISTORY',
        type: 'UNAUTHORIZED_ACTOR',
        messageLangMap: {
            'PT-BR': 'Usuário não tem permissão para listar histórico de substituição de aprovador.',
            'EN-US': 'User is not allowed to list approver replacement history.',
        },
    },
    APPROVER_REPLACEMENT_NOT_FOUND: {
        usecase: 'LIST_APPROVER_REPLACEMENT_HISTORY',
        type: 'APPROVER_REPLACEMENT_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Substituição de aprovador não encontrada.',
            'EN-US': 'Approver replacement not found.',
        },
    },
};
